import PropTypes from 'prop-types'
import React from 'react'

import { Color } from 'constants/color'

import { Wrapper } from './styles'

const Divider = props => <Wrapper {...props} className="divider" />

Divider.propTypes = {
    color: PropTypes.string,
    borderWidth: PropTypes.number,
    opacity: PropTypes.number,
}

Divider.defaultProps = {
    color: Color.unknownColor21,
    borderWidth: 0.5, //px
    opacity: 0.24,
}

export default Divider
